import { GzContentControlWebDataProtectionRulesFormWebComponent } from './component/GzContentControlWebDataProtectionRulesFormWebComponent';

export { GzContentControlWebDataProtectionRulesFormWebComponent };
